<template>
  <header
    class="pos-header"
    :style="
      routeName === '/pos-login'
        ? 'margin-bottom:0px;padding-left:10px;padding-top:10px'
        : 'margin-bottom:0px'
    "
  >
    <div
      class="row"
      :style="
        routeName === '/pos-login' ? 'margin-bottom:0px' : 'margin-bottom:10px'
      "
    >
      <div class="col-lg-12 col-12 align-items-center d-flex alignment-header">
        <div class="align-items-center d-flex">
          <span class="mr-1">
            <img
              src="@/assets/img/logos/logo-dark.png"
              width="60"
              v-if="routeName !== '/pos-login'"
              height="auto"
            />
          </span>
          <!-- routeName === '/pos-login' || -->
          <div
            v-if="
              ((section && section.movieDetail) ||
                routeName === '/pos-booking') &&
                accessLimitation == 'SUPER'
            "
            class="pos-tabs"
          >
            <!----|| routeName === '/pos-login'------>
            <router-link to class="active">POS</router-link>
            <router-link to @click.native.prevent="onSwitchToFnb()"
              >FNB</router-link
            >
          </div>
        </div>
        <div
          class="align-items-center d-flex"
          v-if="routeName !== '/pos-login'"
        >
          <section class="pos_movie_search_n_filters__nav mx-1">
            <article class="movie_view_type_selector_new">
              <!-- FILTER BY MOVIE SECTION -->
              <span
                @click="onChangeFilter(e, 'movie')"
                :class="selectedFilterName === 'movie' ? 'active' : ''"
              >
                {{ $tc("movie", 1) }}
              </span>

              <!-- FILTER BY DATE SELECTION SLIDER -->
              <span
                @click="onChangeFilter(e, 'date')"
                :class="selectedFilterName === 'date' ? 'active' : ''"
              >
                {{ $t("date") }}
              </span>

              <!-- FILTER BY SCREEN SECTION  -->
              <span
                @click="onChangeFilter(e, 'screen')"
                :class="selectedFilterName === 'screen' ? 'active' : ''"
              >
                {{ $tc("screen", 1) }}
              </span>

              <!-- FILTER BY LANGUAGE SECTION -->
              <span
                @click="onChangeFilter(e, 'language')"
                :class="selectedFilterName === 'language' ? 'active' : ''"
              >
                {{ $tc("language", 1) }}
              </span>
            </article>
          </section>
           <span
            class="d-flex ml-3"
            style="height: 40px;cursor:pointer"
            v-b-modal.selectFormat
          >
            <img src="@/assets/img/icons/filter-icon.svg" style="width:35px" />
            <!-- {{ $tc("Filters") }} -->
          </span>
        </div>
        <!-- Sem Version -->
        <!-- style="line-height: 1; min-width: 117px;" -->

        <div
          class="search-input mx-0 d-flex"
          style="align-items: center"
          v-if="routeName !== '/pos-login'"
        >
          <!-- main for gap:10px-->
          <b-form-input
            v-debounce:300="onSearch"
            v-model="searchValue"
            placeholder="Search By Movie"
            class="search_icon"
            type="search"
            id="searchMovie"
            @search="onSearch()"
          ></b-form-input>
          <VkeyboardFloat
            :ID="'searchMovie'"
            :onClickFun="() => (showVKeyboard = !showVKeyboard)"
          />
          <Vkeyboard
            :inputName="'searchHeader'"
            :initialValue="searchValue"
            @changeKeyboardInput="searchValue = $event"
            @onChangeEvent="onSearch"
            :showOrHide="showVKeyboard"
            @onClickClose="
              () => {
                showVKeyboard = false;
              }
            "
          />

          <!-- <input type="search" placeholder="Search..." class="form-control" /> -->
          <div class="d-flex" v-if="routeName !== '/pos-login'">
            <div class="d-flex align-items-center">
              <div
                class="d-flex mr-1"
                style="align-item: center; white-space: nowrap"
              >
                <!-- <div v-if="routeName !== '/pos-login'" class="mx-2 text-blue">{{selectedCinema}}</div> -->
                <div class="text-blue" style="text-align: center">
                  {{ currentDate }}
                </div>
                <div>|</div>
                <div class="">{{ currentTime }}</div>
              </div>
              <img
                :src="getOrganizationDetails.org_logo_url"
                height="auto"
                width="80"
                class=""
              />
            </div>
          </div>

          <b-dropdown
            v-if="USERLOCATIONS.length > 1 && routeName !== '/pos-login'"
            right
            class="pos-header-dropdown"
            variant="pos-dropdown"
          >
            <template v-slot:button-content>
              <span>{{ getUserLocation() }}</span>
            </template>
            <template>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item
                :class="
                  selectedPosUserId == users.user_id ? 'disableLocation' : ''
                "
                :disabled="selectedPosUserId == users.user_id"
                :key="userIndex"
                v-for="(users, userIndex) in USERLOCATIONS"
                @click="OnChangeUserLocation(users)"
              >
                {{ users.cine_name }}
                <div class="text-muted fs-10 p-0 m-0">
                  {{ users.first_name }}&nbsp;{{
                    users.last_name ? users.last_name : ""
                  }}
                  <span
                    v-if="selectedPosUserId == users.user_id"
                    class="font-italic"
                    >&nbsp;(Logged)</span
                  >
                </div>
              </b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
            </template>
          </b-dropdown>

          <b-dropdown
            v-if="token && routeName !== '/pos-login'"
            right
            class="pos-header-dropdown pos-positioning-header"
            variant="pos-dropdown"
            @show="onCheckShift()"
          >
            <template v-slot:button-content>
              <img
                src="@/assets/img/icons/user-profile.svg"
                style="width:40px"
              />
              <!-- <span >{{ getUSINFO() }}</span> -->
            </template>
            <!-- <b-dropdown-item href="#">Settings</b-dropdown-item> -->
            <template v-if="!loading">
              <b-dropdown-divider></b-dropdown-divider>

              <b-dropdown-item @click="lockScreen()"
                >Lock Screen</b-dropdown-item
              >
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item
                v-if="
                  !isLogin &&
                    GetCinemaShiftIsActive &&
                    GetCinemaShiftIsActive === 'Y' &&
                    shiftRunning
                "
                v-on:click="onClickModal()"

                >Close Shift</b-dropdown-item
              >
              <b-dropdown-divider
                v-if="
                  !isLogin &&
                    GetCinemaShiftIsActive &&
                    GetCinemaShiftIsActive === 'Y' &&
                    shiftRunning
                "
              ></b-dropdown-divider>
              <b-dropdown-item @click="openAuthModal"
                >Open Cash Drawer</b-dropdown-item
              >
              <b-dropdown-divider></b-dropdown-divider>

              <!-- <b-dropdown-item v-if="isLogin" v-on:click="onLogout()">Logout</b-dropdown-item> -->
              <b-dropdown-item v-on:click="configureSetting()"
                >Settings</b-dropdown-item
              >

              <b-dropdown-divider></b-dropdown-divider>

              <b-dropdown-item v-on:click="onLogout()">Logout</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>

              <b-dropdown-item>
                <span>
                  {{ semver }} <br />
                  <!-- {{ releaseVersion }} -->
                </span>
              </b-dropdown-item>

              <b-dropdown-divider v-if="DeviceUniqueCode"></b-dropdown-divider>
              <b-dropdown-item v-if="DeviceUniqueCode">
                <!---Device Name-->
                <div class="d-flex mr-3 text-nowrap">
                  <div class="text-blue">Device - {{ DeviceUniqueCode }}</div>
                </div>
                <!---Device Name-->
              </b-dropdown-item>
            </template>
            <div v-else>
              <div class="loader"></div>
            </div>
          </b-dropdown>
        </div>

        <!--Version-->
        <!----div class="d-flex flex-column mr-3 text-center text-nowrap">
          <span> {{ semver }} </span>
          <span> {{ releaseVersion }} </span>
        </div---->

        <!--Version-->

        <!-- <div
          class="d-flex flex-column mr-3 text-center"
          style="line-height: 1; min-width: 117px;"
        >
          <span> Version </span>
          <span> {{ semver }} </span>
        </div>
        <div
          class="d-flex flex-column mr-3 text-center"
          style="line-height: 1; min-width: 117px;"
        >
          <span> Release </span>
          <span> {{ releaseVersion }} </span>
        </div> -->
        <!-- style="line-height: 1; min-width: 117px;" -->
        <!-- <div class="d-flex flex-column mr-3 text-center text-nowrap">  -->

        <!-- <span> Release </span> -->
        <!-- <span> {{ releaseVersion }} </span> -->
        <!-- </div> -->

        <!-- <div class="d-flex mr-2">
          <div class="mx-2 text-blue">{{ CinemaName }}</div>
        </div> -->

        <!--Language Drop Down---->

        <!---b-dropdown right variant="pos-dropdown" class="mr-3">
          <template v-slot:button-content>
            <img
              src="@/assets/img/icons/language-icon.svg"
              height="25px"
              width="25px"
            />
            <span>{{ selectedLanguage }}</span>
          </template>
          <div v-for="(language, index) in languages" :key="index">
            <b-dropdown-item @click="changeLanguage(language)">{{
              language.title
            }}</b-dropdown-item>
            <b-dropdown-divider
              v-if="languages.length - 1 == !index"
            ></b-dropdown-divider>
          </div>
        </b-dropdown--->
        <!--Language Drop Down---->

        <!-- ORG LOGO -->

        <!-- ORG LOGO END -->
        <ManagerAuthLogin
          @AuthValid="onValidateAuth"
          :refId="'authManagerLoginPopup_posHeader'"
        />
        <ManagerAuthLogin :moduleName="'closeShiftAuth'" :onCheckAuth="onCheckAuthentication" :refId="'closeShiftAuth'" />
        <PosSettingsPopup />
      </div>

      <b-modal
      id="confirmation_active_inactive"
      title="Confirmation"
      hide-footer
      hide-header
      centered
    >
      <div class="text-center pb-1 my-3">
        <p class="fs-16 mb-3">Do you want to Close Your Shift ? </p>
        <span class="mx-1"></span>
        <button
          class="btn btn-success btn-success-lg px-4 fs-14"
          v-on:click="onCloseShift()"
        >
          Yes
        </button>

         <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('confirmation_active_inactive')"
        >
          Cancel
        </button>
      </div>
    </b-modal>

    </div>
  </header>
</template>

<script>
import languages from "@/helper/Languages";
import i18n from "@/plugins/i18n";
import CinemaService from "@/services/CinemasService";
import PosService from "@/services/PosService";
import moment from "moment";
import { backendSocket, EventBus } from "@/main.js";
import { mapGetters } from "vuex";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
import { BASEURL } from "@/config/index.js";
import PosSettingsPopup from "@/components/Partials/PosSettingsPopup.vue";
import { Role, CLIENT_NAME } from "@/helper/Role";

export default {
  components: {
    Vkeyboard,
    VkeyboardFloat,
    ManagerAuthLogin,
    PosSettingsPopup
  },
  props: {
    isLogin: {
      type: Boolean,
      default: false
    },
    section: {
      type: Object
    },
    selectedFilterName: {
      type: String
    },
    onChangeFilter: {
      type: Function
    },
    onClickCloseButton: {
      type: Function
    },
    onClickHandler: {
      type: Function
    }
  },
  data() {
    return {
      accessLimitation: "",
      selectedPosUser: "",
      selectedPosUserId: null,
      USERLOCATIONS: [],
      showVKeyboard: false,
      shiftRunning: false,
      loading: true,
      token: null,
      languages,
      selectedLanguage: "English",
      selectedCinema: "",
      DeviceUniqueCode: "",
      hardware_id: "",
      searchValue: "",
      noAuth: false,
    };
  },
  sockets: {
    hardwareId: function(macId) {
      if (macId) {
        this.hardware_id = macId;
      }
    }
  },
  computed: {
    ...mapGetters(["getUserShiftPaymentGrandTotal", "getHealthMeta"]),
    userRole() {
      return this.secureStore.get("USINFO").role_name;
    },
    MANAGER_AUTH_FOR_CHANGES() {
      return this.$store.getters.MANAGER_AUTH_FOR_CHANGES
    },
    shiftDetails() {
      return this.$store.getters.SHIFT_DETAILS;
    },
    totalCashCollected() {
      return this.$store.getters.TOTAL_CASH_COLLECTED;
    },
    GET_CASH_DENOMINATION() {
      return this.$store.getters.GET_CASH_DENOMINATION;
    },
    getShiftClosePaymentModes() {
      let tempArray = this.$store.getters.getUserShiftPaymentTypes || [];

      tempArray.map(x => {
        x["keyboardnsActive"] = false;
        x["keyboardtmActive"] = false;
      });

      console.log("tempArray", tempArray);
      return tempArray;
    },

    semver() {
      return "V 1.0.0";
    },
    USE_TIM_INTEGRATION() {
      return this.$store.getters.USE_TIM_INTEGRATION;
    },
    selectedUserLocation() {
      return this.secureStore.get("USINFO").cine_name;
    },
    releaseVersion() {
      return "03-Jan-22-18:00";
      // return 'R - 18:00 01/11/21'
      // let committedOn = this.getHealthMeta.git.committedOn || ''
      //
      // let readableDate = moment(committedOn)
      // let readableDateWithOffset = moment(committedOn * 1000)
      //
      // return readableDate.isValid()
      //   ? readableDate.format('DD-MMM-YY-HH:mm')
      //   : readableDateWithOffset.isValid()
      //     ? readableDateWithOffset.format('DD-MMM-YY-HH:mm')
      //     : 'v1.0'
    },
    GetCinemaShiftIsActive() {
      return this.secureStore.get("BRCISH");
    },
    FloatValue: function() {
      return this.$store.getters.isFloatAmountValue;
    },
    routeName: function() {
      return this.$route.path;
    },
    currentDate() {
      return this.$store.getters.CURRENT_DATE;
    },
    currentTime() {
      return this.$store.getters.CURRENT_TIME;
    },
    CinemaName() {
      return (
        this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO").cine_name
      );
    },
    getOrganizationDetails() {
      return this.$store.getters.getOrganizationDetails;
    },
    userInfo() {
      return this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO").first_name &&
        this.secureStore.get("USINFO").last_name
        ? this.secureStore.get("USINFO").first_name +
            " " +
            this.secureStore.get("USINFO").last_name
        : "Admin";
    }
  },
  beforeMount() {
    this.accessLimitation = this.secureStore.get("BRUACS");
  },
  mounted() {
    this.setTime();
    this.updateTime();
    this.token = window.localStorage.getItem("JWT_TOKEN");
    this.DeviceUniqueCode = window.localStorage.getItem("deiviceUniqueCode")
      ? window.localStorage.getItem("deiviceUniqueCode")
      : "";
    console.log(
      "Device code is",
      window.localStorage.getItem("deiviceUniqueCode")
    );
    // let cineid = this.secureStore.get("USINFO") && this.secureStore.get("USINFO")['cinema_id'] ? this.secureStore.get("USINFO").cinema_id : '';
    // cineid.length >0 ? this.getCinemaList(cineid) : '';
    // if(this.secureStore.get("USINFO")['pos_location_access']) {
    //   this.getPosUserLocations();
    // }
    this.getPosUserLocations();
  },
  methods: {
    onCheckAuthentication(response) {
      const {valid, name} = response
      if(valid) {
        if(name == 'closeShiftAuth') {
          this.$bvModal.hide('closeShiftAuth');
          this.onCloseShift()
        }
      }
    },
     onClickModal() {
      console.log('CLOSE SHIFT Modal Opened');
      if( CLIENT_NAME.IRAQ == this.CLIENT_SETUP_NAME ) {
        if(this.MANAGER_AUTH_FOR_CHANGES == 'Y') {
          this.$bvModal.show('closeShiftAuth');
        } else {
          this.$bvModal.show('confirmation_active_inactive')
        }
      } else {
        this.$bvModal.show('confirmation_active_inactive')
      }
    },
    openAuthModal() {},
    getUSINFO() {
      let text = `Admin`;
      let loggedUser = this.secureStore.get("USINFO");
      text =
        loggedUser.first_name +
        (loggedUser.last_name ? " " + loggedUser.last_name : "");
      return text;
    },
    onValidateAuth(valid) {
      console.log({ valid });
      console.log(this.secureStore.get("USINFO"));
      if (valid) {
        this.$bvModal.hide("authManagerLoginPopup_posHeader");
        // if (userAgent.indexOf(" electron/") > -1) {
        //   if (backendSocket && backendSocket.connected) {
        //     backendSocket.emit("on_user_login", {
        //       user: data.data.user,
        //       hardware_id: this.hardware_id
        //     });
        //   }
        // }
        // setTimeout(() => {
        if (this.$socket) {
          console.log("print_ticket from pos_login3123425454");
          this.$socket.emit("on_print_ticket", {
            cinema_id: this.secureStore.get("USINFO").cinema_id,
            baseurl: BASEURL,
            ttype: "shift-manager-login",
            openDrawer: "Y",
            loginDateTime: new Date()
          });
          console.log("print_ticket from pos_login");
        }
        // }, 2000);
      }
    },

    getUserLocation() {
      return this.secureStore.get("USINFO").cine_name;
    },
    configureSetting() {
      this.$bvModal.show("posSettingsModal");
    },
    openEftFunctions() {
      this.$bvModal.show("eft_tim_terminal_functions");
    },
    checkBalance() {
      balance();
    },
    OnChangeUserLocation(user) {
      let payload = {
        dflt_user_id: this.secureStore.get("DFLT_USINFO")
          ? this.secureStore.get("DFLT_USINFO").user_id
          : null,
        new_user_id: user.user_id
      };

      PosService.changeLoggedUserCinema(payload)
        .then(async response => {
          const { data } = response;
          console.log("data", data);
          let finalObj = {};
          let PromiseArray = this.usersArray.map(x => {
            finalObj[x] = data.data.user[x] || null;
          });
          console.log("finalObj", finalObj);
          await Promise.all(PromiseArray);

          if (data.data.user && data.data.user.shift_id) {
            this.$store.dispatch("OnPOSLogin", true);

            this.secureStore.set("USINFO", finalObj);

            this.$cookie.set("BRHSID", data.data.token, {
              expires: "1Y"
            });

            this.$store.dispatch("onSetAndSendLog", {
              cinema_id: finalObj.cinema_id,
              user_id: finalObj.user_id,
              action: "POS User Logged In",
              page_name: "POS LOGIN",
              api_name: window.location.hash
            });

            this.$cookie.set("BRLF", "pos-login");
            window.localStorage.setItem("JWT_TOKEN", data.data.token);

            this.secureStore.set(
              "BRCISH",
              data.data.user.cine_include_shift_close
            );

            this.secureStore.set(
              "BRCIFTAT",
              data.data.user["cine_include_float_amount"]
            );

            this.$store.dispatch("userShiftStart", {
              usl_id: data.data.user.user_id,
              user_shift_id: data.data.user.shift_id,
              cine_include_shift_close: data.data.user.cine_include_shift_close,
              cine_include_float_amount:
                data.data.user.cine_include_float_amount
            });

            var userAgent = navigator.userAgent.toLowerCase();

            if (userAgent.indexOf(" electron/") > -1) {
              if (backendSocket && backendSocket.connected) {
                backendSocket.emit("on_user_login", {
                  user: data.data.user,
                  hardware_id: this.hardware_id
                });
              }
            }
            (this.selectedPosUserId = user.user_id),
              (this.selectedPosUser = user);
            this.onClickHandler("Refresh");
            this.onClickCloseButton();
            // location.reload();
          } else {
            this.$toasted.show("Shift is Not Created For Selected Location");
          }
        })
        .catch(err => {
          console.log("Error:", err);
        });
    },
    getPosUserLocations() {
      if (this.secureStore.get("DFLT_USINFO").user_id) {
        let payload = {
          user_id: this.secureStore.get("DFLT_USINFO").user_id
        };
        PosService.GetPosLocationsUsers(payload)
          .then(response => {
            const { data } = response;
            if (
              data &&
              data.status &&
              data.Records &&
              data.Records.length > 0
            ) {
              this.USERLOCATIONS = data.Records;
              let loggedUserid = this.secureStore.get("USINFO").user_id;
              let loggedUser = this.USERLOCATIONS.find(
                x => loggedUserid == x.user_id
              );
              if (loggedUser) {
                this.selectedPosUserId = loggedUser.user_id;
                this.selectedPosUser = loggedUser;
              }
            } else {
              this.USERLOCATIONS = [];
            }
            console.log("this.USERLOCATIONS", this.USERLOCATIONS);
          })
          .catch(err => {
            console.log("ERROR:", err);
          });
      }
    },
    onSearch() {
      this.$store.dispatch("SEARCH", this.searchValue);
    },
    lockScreen() {
      window.localStorage.setItem("LockedSinced", moment().format("HH:mm:ss"));
      window.localStorage.setItem("Locked", true);
      this.$store.dispatch("onSetAndSendLog", {
        action: `User Locked the Screen`
      });
      console.log("time", moment().format("HH:mm:ss"));
      this.$router.push({
        path: "pos-lock-screen"
      });
    },
    onCheckShift: function() {
      this.loading = true;
      PosService.shiftChecker().then(response => {
        const { data } = response;
        this.loading = false;
        if (data.status) {
          this.shiftRunning = data.shiftRunning;
        } else {
          this.shiftRunning = true;
        }
      });
    },
    updateTime: function() {
      let self = this;
      setInterval(function() {
        self.setTime();
      }, 60000);
    },
    setTime: function() {
      this.$store.dispatch("SET_CURRENT_TIME");
    },
    onSwitchToFnb: function() {
      this.$store.dispatch("MAKE_SEAT_BOOKING_DETAILS_EMPTY", {
        doNotShowError: false
      });
      let userInfo = this.secureStore.get("USINFO");
      if (userInfo) {
        userInfo["role_name"] = "FnB POS Operator";

        this.secureStore.set("USINFO", userInfo);
        this.$router.push({
          path: "pos-fnb"
        });
      } else {
        this.$router.push({
          path: "pos-fnb-login"
        });
      }
    },
    closeEftSession() {
      localStorage.setItem("ECR_INIT_STATUS", false);
      // if(typeof balance == 'function') {
      //    balance();
      // }

      if (typeof deactivate == "function") {
        setTimeout(() => {
          deactivate();
        }, 1500);
      }
    },
    onCloseShift: function() {
      // const { cine_sell_fnb_in_boxoffice } = this.secureStore.get("USINFO");
      let checkFlag = this.secureStore.get("BRCIFTAT");
      this.closeEftSession();
      // path:close-shift
      if (checkFlag && checkFlag == "Y") {
        this.$store.dispatch("onResetFnBStoreState");
        this.$router.push({
          path: "/close-shift"
        });
        this.$store.dispatch("onSetAndSendLog", {
          action: `Pos User selected Close Shift Button `,
          page_name: "pos booking",
          api_name: ""
        });
      }
      // if (checkFlag && checkFlag == "Y") {
      //   this.$store.dispatch("onSetAndSendLog", {
      //     action: `Pos User selected Close Shift Button `,
      //     page_name: "pos booking",
      //     api_name: ""
      //   });
      //   let payload = {
      //     operator_type:
      //       this.userRole == "FnB POS Operator"
      //         ? "pos-fnb"
      //         : this.userRole == "POS Operator"
      //         ? "pos-booking"
      //         : "box-office-fnb", //'pos-fnb' // 'box-office-fnb'
      //     shift_id: this.shiftDetails.shift_id,
      //     manager_user_id: this.shiftDetails.manager_user_id,
      //     operator_user_id: this.shiftDetails.operator_user_id,
      //     currency_id: this.shiftDetails.currency_id,
      //     scr_total_amount_collected: this.getUserShiftPaymentGrandTotal,
      //     scr_approval_status: false,
      //     scr_is_active: false,
      //     //
      //     shiftClosePayments: this.$store.getters.getUserShiftPaymentTypes,
      //     cashDenomination: this.GET_CASH_DENOMINATION,
      //     Remark: this.Remark
      //   };
      //   PosService.onCloseShift(payload)
      //     .then(response => {
      //       const { data } = response;
      //       if (data && data.status) {
      //         this.$store.dispatch("userPosShiftClose", {});
      //         this.$toasted.show(data.message);
      //         var myItem = null;
      //         if (localStorage.getItem("ECR_INFO")) {
      //           myItem = localStorage.getItem("ECR_INFO");
      //         }
      //         window.localStorage.clear();
      //         if (myItem) {
      //           localStorage.setItem("ECR_INFO", myItem);
      //         }
      //         this.$cookie.delete("BRHSID");
      //         this.$store.dispatch("clearShiftData");
      //         this.$store.dispatch("SET_TOTAL_CASH_COLLECTED", 0);
      //         if (this.userRole == "FnB POS Operator") {
      //           this.$router.push({
      //             path: "pos-fnb-login"
      //           });
      //         } else {
      //           this.$router.push({
      //             path: "pos-login"
      //           });
      //         }
      //       } else {
      //         this.$toasted.show(data.message);
      //       }
      //     })
      //     .catch(err => {
      //       this.$toasted.show(err);
      //     });
      // }
      else {
        var myItem = null;
        if (localStorage.getItem("ECR_INFO")) {
          myItem = localStorage.getItem("ECR_INFO");
        }
        window.localStorage.clear();
        if (myItem) {
          localStorage.setItem("ECR_INFO", myItem);
        }
        this.$cookie.delete("BRHSID");
        this.$store.dispatch("onResetFnBStoreState");
        this.$toasted.show("Shift Closed Successfully.");
        this.$router.push({
          path: "pos-login"
        });
      }
    },
    onLogout: async function() {
      this.$store.dispatch("onSetAndSendLog", {
        action: `Pos User selected logout button`,
        page_name: "close shift",
        api_name: ""
      });
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf(" electron/") > -1) {
        if (backendSocket && backendSocket.connected) {
          backendSocket.emit("on_user_logout", {
            hardware_id: this.DeviceUniqueCode
          });
        }
      }
      // window.localStorage.removeItem("JWT_TOKEN");
      await this.$store.dispatch("onUserShiftQuit", {});
      await this.$store.dispatch("onResetFnBStoreState");
      await this.$store.dispatch("onResetDateStoreState");
      await this.$store.dispatch("MAKE_DATA_EMPTY");
      var myItem = null;
      if (localStorage.getItem("ECR_INFO")) {
        myItem = localStorage.getItem("ECR_INFO");
      }
      window.localStorage.clear();
      if (myItem) {
        localStorage.setItem("ECR_INFO", myItem);
      }
      this.$cookie.delete("BRHSID");
      this.$router.push({
        path: "pos-login"
      });
    },
    changeLanguage: function({ language, title }) {
      i18n.locale = language;
      this.selectedLanguage = title;
    },

    getCinemaList: function(cinema_id) {
      CinemasService.GetActiveCinemas({ activekey: "cine_is_active" })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map(x => {
              if (x.cine_id == cinema_id) {
                this.selectedCinema = x.cine_name;
              }
            });
            this.getCinemaSettings(cinema_id);
          } else {
            // Show Error Message:
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch On GetActiveCinemas :", error);
        });
    }
  }
};
</script>

<style>
.disableLocation {
  opacity: 0.5;
  cursor: not-allowed;
}
.loader {
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 25px;
  height: 25px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
  margin: 0 auto;
  margin-top: 10px;
  margin-bottom: 10px;
}
.alignment-header {
  justify-content: space-between;
}

@media screen and (max-width: 1000px) {
  .alignment-header {
    flex-wrap: nowrap;
  }
}
@media screen and (min-width: 1080px) and (max-width: 1500px) {
  .alignment-header {
    justify-content: space-between;
  }
}
@media screen and (min-width: 1100px) {
  .main {
    gap: 10px;
  }
}
/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.pos-positioning-header {
  position: absolute !important;
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/posHeader.vue